export default function(value) {
  if (!value) return "";
  const decryptedValue = this.CryptoJS.AES.decrypt(value, this.SecretKey).toString(
    this.CryptoJS.enc.Utf8
  );
  return Number(decryptedValue);
}
